<template>
  <!-- 轮播 -->
  <div class="detail__swiper-container">
    <swiper class="swiper__wrapper" v-if="picturesList" ref="case-detail-swiper" :options="options">
      <swiper-slide v-for="(picture, index) in picturesList" :key="index" class="swiper__slide"
        :data-pictureid="picture.id">

        <div class="currentLabels" v-if="isShowLabel && picture.coordinateArr">
          <template v-if="picture.coordinateArr.length > 0">
            <div class="label__item" v-for="label in picture.coordinateArr" :key="label.id" :style="{
              left: label.x_coordinate,
              top: label.y_coordinate
            }">
              <p>{{ label.tag }}</p>
              <div v-if="userInfo && label.user_id == userInfo.id" class="deleteBt" @click="onDeleteTag"
                :data-tagid="label.id" :data-pictureid="picture.id"></div>
            </div>
          </template>
        </div>


        <img v-if="caseid&&caseid!=0&&caseid!=''" :src="parseImage(picture.url || picture)" alt=""
          @click="routergo()" />

        <img v-else :src="parseImage(picture.url || picture)" alt=""
          @click="enablePreview && onPreview(picture.url || picture)" />



      </swiper-slide>
    </swiper>
    <div class="swiper__pagination">
      <a href="#" class="pagination__item"></a>
      <a href="#" class="pagination__item --active"></a>
    </div>
    <div class="swiper__direction-bts">
      <div class="bts__item --prev"></div>
      <div class="bts__item --next"></div>
    </div>
    <div v-if="!$isMobile && labelShow && !isPreview" class="swiper__label-bts">
      <div class="label__item" @click="isShowLabel = !isShowLabel">
        <i class="item__icon icon" :class="[!isShowLabel ? 'icon-show-label' : 'icon-hidden-label']"></i>
        <p>{{ !isShowLabel ? "显示标签" : "隐藏标签" }}</p>
      </div>
      <div class="label__item" @click="openEdit">
        <i class="item__icon icon icon-create-label"></i>
        <p>添加标签</p>
      </div>
      <div v-if="caseid&&caseid!=0&&caseid!=''" class="label__item" @click="routergo()"
        style="width:160px;background-color:royalblue;">
        <i class="item__icon icon icon-pwb-lq-label" style="width:40px;"></i>
        <el-tooltip class="item" effect="dark" content="点击跳转，查看更多信息" placement="top">
          <p style="width:120px;color: antiquewhite;">powered by 零泉</p>
        </el-tooltip>
      </div>
    </div>

    <div class="draggableWrapper" v-if="showEdit">
      <vue-draggable-resizable :resizable="false" :parent="true" :min-width="draggable.w" :h="draggable.h"
        :x="draggable.x" :y="draggable.y" @dragstop="onDragStop">
        <div class="edit__container">
          <el-input v-model="form.text" placeholder="可输入20个字" maxlength="20"></el-input>
          <div class="actionbt add" @click="onSbumit"></div>
          <div class="actionbt cancel" @click="onCanCel"></div>
        </div>
      </vue-draggable-resizable>
    </div>
    <template v-if="preview">
      <image-viewer :z-index="2000" :on-close="closeViewer" :initial-index="imageIndex"
        :url-list="parseImage(previewSrcList)"></image-viewer>
    </template>



    <template>
      <div>
        <el-dialog title="用户授权协议" :visible.sync="dialogVisible" width="50%">
          <el-form :model="authMobileFormModel" ref="formRef" label-width="50%" size="small"
            class="designer-add-info-c clearfix">
            <div class="lsm-container" style="height:300px;">
              <el-scrollbar class="scrollbar-wrapper" style="height:100%;line-height:22px;">
                本《信息授权协议》（以下简称“本协议”）由上海材赋信息科技有限公司，即材料在线平台（以下简称“材料在线”）与用户（以下简称“您”）进行缔结，对双方具有同等法律效力。<br />
                <br />
                在您使用“灵感板块功能”相关服务（以下简称“本服务”）之前，请您务必审慎阅读、充分理解本协议各条款内容。如果您不同意本协议的任一或全部条款内容，请不要以确认形式进行下一步操作（包括但不限于勾选/点击同意、填写/提交个人信息等）或使用本服务。一旦您以确认形式进行下一步操作或使用本服务的，即表示您与材料在线已达成协议关系，您自愿接受本协议并遵守本协议项下的全部约定。<br />

                1.在您点击确定/授权后，当您使用灵感板块服务时，我们会将您的账户、手机号码及相关信息共享给材料在线委托的技术服务代理商苏州零泉科技有限公司。前述第三方将使用您的前述信息用于第三方为您提供服务。页面提示上可能会展示具体授权对象、授权字段名称、范围等，授权字段通过加密通道传递给第三方。<br />
                2. 您理解，材料在线是中立平台的提供者，第三方服务由该第三方独立运营并独立承担全部责任。<br />
                3.
                材料在线在遵守“合法正当、最小必要、目的明确”原则的前提下共享您的个人信息。我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作伙伴的信息保护义务与责任，与业务合作伙伴在合作前签署关于数据安全的保护协议。<br />
                4. 材料在线深知个人信息对您的重要性，因此材料在线非常重视保护您的个人信息，亦将您的个人信息以高度审慎的义务对待和处理。<br />
                5. 本协议的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向被告住所地人民法院提起诉讼。<br />
                6. 如您在阅读本协议过程中有任何疑惑或其他相关事宜的，您可通过材料在线客服渠道联系材料在线；同时，您也可以发邮件至cailiaozaixian@163.com。材料在线会尽快为您作出解答。<br />


                <p>
                  <br />
                </p>
              </el-scrollbar>
            </div>
            <br />
            <p style="text-align:center">下滑滚动查看协议内容</p>

            <br />
            <el-radio v-model="radio" label="1" color='#fabe00'><label>授权账号信息及手机号，以便使用该功能</label>
            </el-radio>

            <el-form-item>
              <el-button type="primary" @click="toCreateAuth">确 定</el-button>
              <el-button @click="cancelCreateAuth" class="el-button-cancel">取 消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </template>


  </div>
</template>



<script>
import { getLqRedirectUrl } from '@/api/lq';
import { createAuth, isAuth } from '@/api/user';
import localstorage from '@/assets/utils/localstorage';
import { parseImage } from '@/filters';
import * as dict from '@/store/storage-dict';
import ImageViewer from 'element-ui/packages/image/src/image-viewer.vue';
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import VueDraggableResizable from 'vue-draggable-resizable';
import { mapState } from 'vuex';


let prevOverflow;

export default {
  components: {
    Swiper,
    SwiperSlide,
    VueDraggableResizable,
    ImageViewer,
  },
  name: 'detail-swiper',
  props: {
    caseid: {
      default: 0,
    },
    pictures: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        autoplay: true,
        loop: true,
        pagination: {
          el: '.swiper__pagination',
        },
        navigation: {
          nextEl: '.swiper__direction-bts .--next',
          prevEl: '.swiper__direction-bts .--prev',
        },
      }),
    },
    labelShow: {
      type: Boolean,
      default: false,
    },
    enablePreview: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currItemObj: {
        pageType: 2,
        id: 0,
        imageType: 2,
      },
      radio: '1',
      authMobileFormModel: {
        authMobile: false,
      },
      isAuthEd: false,
      dialogVisible: false,
      preview: false,
      draggable: {
        w: 300,
        h: 28,
        x: 0,
        y: 0,
      },
      isShowLabel: false,
      text: '',
      showEdit: false,
      currentPictureId: 0,
      loading: false,
      form: {
        x: '',
        y: '',
        text: '',
      },
      src: null,
      picturesList: [],
    };
  },
  computed: mapState('user', {
    userInfo: (state) => state.info,
    imageIndex() {
      let previewIndex = 0;
      const srcIndex = this.previewSrcList.indexOf(this.src);
      if (srcIndex >= 0) {
        previewIndex = srcIndex;
      }
      return previewIndex;
    },
    previewSrcList() {
      const temp = this.picturesList.map((item) => item.url);
      return temp;
    },
  }),
  watch: {
    pictures: {
      handler(val) {
        console.log(val);
        this.picturesList = val.map((item) => {
          const temp = item.name && !item.raw
            ? {
              url: item.name,
            }
            : item;
          return temp;
        });
      },
      immediate: true,
    },
    showEdit(val) {
      if (val) {
        this.form.text = '';
      }
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      const swiper = that.$refs['case-detail-swiper'].$swiper;
      const { width, height } = swiper.$wrapperEl['0'].getBoundingClientRect();
      that.draggable.x = width / 2;
      that.draggable.y = height / 2;
      that.form.x = that.draggable.x;
      that.form.y = that.draggable.y;
      that.currentPictureId = Array.from(swiper.slides).find(
        (item, index) => index === swiper.activeIndex,
      ).dataset.pictureid;
      swiper.on('slideChange', () => {
        that.currentPictureId = Array.from(swiper.slides).find(
          (item, index) => index === swiper.activeIndex,
        ).dataset.pictureid;
        that.onCanCel();
      });
    });
    this.checkisAuthEd();
  },
  methods: {
    async routergo() {

      this.currItemObj.id = this.caseid;

      if (!localstorage.get(dict.token)) {
        Message({
          type: 'error',
          message: '请您先登录',
          duration: 1000,
          onClose() {
            router.push({
              path: '/login',
            });
          },
        });
        return false;
      }
      if (this.isAuthEd != true) {
        this.dialogVisible = true;
      }
      else {
        const res = await getLqRedirectUrl(this.currItemObj);
        window.open(res.data)
      }
    },
    cancelCreateAuth() {
      this.dialogVisible = false;
    },
    async toCreateAuth() {
      this.dialogVisible = false;
      await createAuth({
        mobile: this.authMobileFormModel.authMobile == true ? 1 : 0
      });

      const res = await getLqRedirectUrl(this.currItemObj);
      window.open(res.data)
    },
    async checkisAuthEd() {
      if (this.isAuthEd == true) {
        return;
      }
      const res = await isAuth();
      this.isAuthEd = res.data;
    },

    onDragStop(x, y) {
      this.form.x = x;
      this.form.y = y;
    },
    onSbumit() {
      const that = this;
      if (that.form.text === '') {
        that.$message({
          type: 'error',
          message: '请填写内容',
        });
      } else if (that.form.text.length > 20) {
        that.$message({
          type: 'error',
          message: '内容过长',
        });
      }
      const postData = {
        picture_id: that.currentPictureId,
        x_coordinate: `${that.form.x}px`,
        y_coordinate: `${that.form.y}px`,
        tag: that.form.text,
        color: '#fff',
      };
      const loading = that.$loading({
        lock: true,
        text: '添加中...',
      });
      that.$http
        .post('html/caseller/pictureTag', postData)
        .then((res) => {
          postData.id = res.data.id;
          postData.user_id = that.userInfo.id;
          // 添加
          that.picturesList.map((item) => {
            const temp = item;
            if (Number(temp.id) === Number(postData.picture_id)) {
              temp.coordinateArr.push(postData);
            }
            return temp;
          });
          that.$message({
            type: 'success',
            message: '添加成功',
          });
          that.showEdit = false;
        })
        .finally(() => {
          loading.close();
        });
    },
    onCanCel() {
      this.showEdit = false;
    },
    openEdit() {
      const that = this;
      if (!that.userInfo) {
        that.$message({
          type: 'error',
          message: '请先登录',
          duration: 500,
          onClose() {
            that.$router.push({
              path: '/login',
            });
          },
        });
      } else {
        that.showEdit = true;
      }
    },
    onDeleteTag(e) {
      const that = this;
      const { tagid, pictureid } = e.currentTarget.dataset;
      that.$confirm('确认删除此条标签吗？', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          const tempInstance = instance;
          if (action === 'confirm') {
            tempInstance.confirmButtonLoading = true;
            tempInstance.confirmButtonText = '删除中...';
            that.$http
              .post('html/caseller/pictureCoorDel', {
                id: tagid,
              })
              .then(() => {
                const pics = [];
                // 删除
                this.picturesList.forEach((item, index) => {
                  const temp = item;
                  if (Number(temp.id) === Number(pictureid)) {
                    const labels = temp.coordinateArr.filter((l) => Number(l.id) !== Number(tagid));
                    temp.coordinateArr = labels;
                  }
                  pics[index] = temp;
                });
                that.picturesList = pics;
                that.$message({
                  type: 'success',
                  message: '删除成功',
                });
              })
              .finally(() => {
                tempInstance.confirmButtonLoading = false;
                tempInstance.confirmButtonText = '确定';
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    onPreview(url) {
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.src = url;
      this.preview = true;
    },
    closeViewer() {
      document.body.style.overflow = prevOverflow;
      this.preview = false;
    },
    parseImage(val) {
      return val.indexOf('blob') >= 0 ? val : parseImage(val);
    },
  },
};
</script>

<style>
.el-radio__label {
  margin-right: 10px;
  color: #000 !important;
  font-weight: 200;
}

.el-radio__input.is-checked {
  color: #fabe00 !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background: #fabe00 !important;
  border-color: #fabe00 !important;
}
</style>
